import LookerReportType from '@/Enums/Looker/ReportType.enum';
import { IBaseDataReport } from '@/Interfaces/Attribution/Report.interface';
import { BEESWAX_MAX_RETRIES } from '@/constants/beeswax/asyncReport';
import { ATTRIBUTION_BEESWAX_LOOKER_ENDPOINT } from '@/constants/endpoints';
import { getBeeswaxAttributionFilter } from '@/helpers/attribution/filters';
import { fetchLookerReport } from '@/helpers/beeswaxReports';
import { RootState } from '@/store';
import { selectWebVisitsFilters } from '@/store/selectors/attribution/webVisits.selectors';
import { selectMeRole } from '@/store/selectors/me.selectors';
import {
  selectRibeyeWithBeeswaxClients,
  selectRibeyeWithBeeswaxWhitelabels,
} from '@/store/selectors/sharedApi.selectors';
import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';

export const attributionRequestHandler =
  <TReport = IBaseDataReport>(
    reportType: LookerReportType,
    fallbackValues: TReport | IBaseDataReport = {
      report: [],
    },
  ): AsyncThunkPayloadCreator<TReport, { signal?: AbortSignal }> =>
  async (payload, { getState }) => {
    const state = getState() as RootState;

    const role = selectMeRole(state);
    const filters = selectWebVisitsFilters(state);

    const clients = selectRibeyeWithBeeswaxClients(state);
    const whitelabels = selectRibeyeWithBeeswaxWhitelabels(state);

    const appliedFilter = getBeeswaxAttributionFilter(filters, role, clients, whitelabels);
    if (!appliedFilter.advertiserIds?.length && !appliedFilter.campaignIds?.length) {
      return fallbackValues;
    }

    const reportResponseData = await fetchLookerReport({
      signal: payload?.signal,
      body: {
        reportType,
        filters: appliedFilter,
      },
      maxRetries: BEESWAX_MAX_RETRIES,
      url: ATTRIBUTION_BEESWAX_LOOKER_ENDPOINT,
    });

    return { ...(reportResponseData ?? fallbackValues), filters };
  };
